import classNames from 'classnames'

export function classnames(className: string | null, ...props: any[]): string {
    return classNames(!className ? undefined : `sw-halo-${className}`, ...props)
}
